<template>
  <v-tooltip bottom :disabled="!tooltip">
    <v-btn v-if="error" slot="activator" :disabled="disabled" :loading="loading" fab dark :color="color">
      <v-icon v-if="icon">{{ icon }}</v-icon>
    </v-btn>
    <v-btn v-else
           slot="activator"
           :disabled="disabled"
           :loading="loading"
           class="nx-round-button"
           :class="classes"
           :color="color"
           fab
           dark>
      <v-icon v-if="icon">{{ icon }}</v-icon>
    </v-btn>
    <span v-html="tooltip"></span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'nx-round-button',
  props: {
    error: {
      type: [Number, String],
    },
    icon: {
      type: String,
    },
    color: {
      type: String,
    },
    tooltip: {
      type: String,
    },
    loading: {
      type: Boolean,
    },
    classes: {
      type: String,
    },
    disabled: {
      type: Boolean,
    },
  },
};
</script>

<style lang="stylus">
.nx-round-button {
  .v-badge__badge {
    right: -5px;
  }

  &.v-badge--left .v-badge__badge {
    left: -5px;
  }
}

.theme--dark .v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat),
.application .theme--dark.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat) {
  &.nx-form-button {
    background-color: rgba(158, 158, 158, 1) !important;
    color: #fff
  }
}
</style>
